module.exports = __webpack_public_path__ + "media/images/edion/top/4-0a8e97f2babc8d2eabb23ee44a420ac7.png";